"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactBootstrap = require("react-bootstrap");
var _FormSearch = _interopRequireDefault(require("../Form/FormSearch"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * The third tier of the Main Menu, which is where Search lives.
 */
const ThirdTier = _ref => {
  let {
    expanded,
    navSettings,
    onSearchCancel,
    searchNavId
  } = _ref;
  const searchRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    if (expanded) {
      searchRef.current.focus();
    }
  }, [expanded]);

  // copy formParameters, since later 'pop' will modify this array
  const formParameters = Object.assign([], navSettings.searchOptions?.formParameters);
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Container, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Navbar.Collapse, {
    className: `${expanded && 'show' || ''}`,
    id: searchNavId
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    xs: 12,
    lg: {
      span: 8,
      offset: 2
    }
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form, {
    action: navSettings.searchOptions?.formAction,
    inline: true,
    method: navSettings.searchOptions?.formMethod
  }, /*#__PURE__*/_react.default.createElement(_FormSearch.default, {
    id: "site-search",
    name: formParameters.find(_ref2 => {
      let {
        type
      } = _ref2;
      return type === 'input';
    })?.name,
    placeholder: "What are you looking for?",
    searchType: "explicit",
    ref: searchRef
  }), formParameters.filter(_ref3 => {
    let {
      type
    } = _ref3;
    return type === 'hidden';
  }).map(_ref4 => {
    let {
      name,
      value,
      type
    } = _ref4;
    return /*#__PURE__*/_react.default.createElement("input", {
      type: type,
      name: name,
      value: value,
      key: name
    });
  }), /*#__PURE__*/_react.default.createElement("button", {
    "aria-controls": searchNavId,
    "aria-expanded": expanded,
    "aria-label": "Close search",
    className: "btn btn-inline search-cancel",
    onClick: onSearchCancel,
    type: "button"
  }, "Cancel")))));
};
var _default = exports.default = ThirdTier;
ThirdTier.propTypes = {
  /** A flag indicating if the search nav displayed. */
  expanded: _propTypes.default.bool.isRequired,
  /** Settings for the form submission data. */
  navSettings: _propTypes.default.any,
  /** Handle the event when the "Cancel" text link is clicked. */
  onSearchCancel: _propTypes.default.func.isRequired,
  /** The ID of the search nav, set by the parent. */
  searchNavId: _propTypes.default.string.isRequired
};
ThirdTier.defaultProps = {
  navSettings: {
    showSearch: false
  }
};